import React from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";

export default class IndicationsBlockEn extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeStep: 0, zone: "visage", indication: "effacer-rides" };
    this.changeStep = this.changeStep.bind(this);
    this.changeZone = this.changeZone.bind(this);
    this.changeIndication = this.changeIndication.bind(this);
  }

  changeStep(newStep) {
    this.setState({ activeStep: newStep });
  }

  changeZone(newZone) {
    this.setState({ zone: newZone, activeStep: 1 });
  }

  changeIndication(newIndication) {
    this.setState({ indication: newIndication, activeStep: 2 });
  }

  render() {
    return (
      <div>
        <MultiStep>
          {this.state.activeStep === 0 && (
            <Wrapper>
              <Step>
                <StepNumber>Step 1/3</StepNumber>
                Select a body region
              </Step>

              <CardWrapper>
                <Card onClick={() => this.changeZone("visage")}>
                  <Img src="/visage.jpg" alt="Aesthetic facial treatments" />
                  <CardTitle>Face</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("regard")}>
                  <Img src="/regard.jpg" alt="Aesthetic eye treatments" />
                  <CardTitle>Eyes</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("nez")}>
                  <Img src="/nez.jpg" alt="Aesthetic nose treatments" />
                  <CardTitle>Nose</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("oreilles")}>
                  <Img src="/oreilles.jpg" alt="Aesthetic ear treatments" />
                  <CardTitle>Ears</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("seins")}>
                  <Img src="/seins.jpg" alt="Aesthetic breast treatments" />
                  <CardTitle>Breast</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("silhouette")}>
                  <Img
                    src="/silhouette.jpg"
                    alt="Aesthetic body contouring treatments"
                  />
                  <CardTitle>Body contouring</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("jambes")}>
                  <Img src="/jambes.jpg" alt="Aesthetic leg treatments" />
                  <CardTitle>Legs</CardTitle>
                </Card>
                <Card onClick={() => this.changeZone("peau")}>
                  <Img src="/peau.jpg" alt="Aesthetic skin treatments" />
                  <CardTitle>Skin</CardTitle>
                </Card>
              </CardWrapper>
            </Wrapper>
          )}

          {this.state.activeStep === 1 && (
            <Wrapper>
              <Step>
                <StepNumber>Step 2/3</StepNumber>
                Select a concern
              </Step>

              {this.state.zone === "visage" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() => this.changeIndication("effacer-rides")}
                    >
                      <Img
                        src="/effacer-rides.jpg"
                        alt="Erase facial wrinkles and fine lines"
                      />
                      <CardTitle>
                        Erase facial wrinkles and fine lines
                      </CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("restaurer-volumes")}
                    >
                      <Img
                        src="/restaurer-volumes.jpg"
                        alt="Restore the volume of my face"
                      />
                      <CardTitle>Restore the volume of my face</CardTitle>
                    </Card>

                    <Card
                      onClick={() =>
                        this.changeIndication("supprimer-imperfections")
                      }
                    >
                      <Img
                        src="/peau.jpg"
                        alt="Remove skin imperfections"
                      />
                      <CardTitle>
                        Remove skin imperfections
                      </CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("rajeunir-peau")}
                    >
                      <Img
                        src="/rajeunir-peau.jpg"
                        alt="Rejuvenate the skin of my face"
                      />
                      <CardTitle>Rejuvenate the skin of my face</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "regard" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() =>
                        this.changeIndication("modifier-forme-paupieres")
                      }
                    >
                      <Img
                        src="/modifier-forme-paupieres.jpg"
                        alt="Change the shape of my eyelids"
                      />
                      <CardTitle>Change the shape of my eyelids</CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("tiers-superieur")}
                    >
                      <Img
                        src="/tiers-superieur.jpg"
                        alt="Rejuvenate the upper third of the face"
                      />
                      <CardTitle>
                        Rejuvenate the upper third of the face
                      </CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("cernes")}>
                      <Img src="/cernes.jpg" alt="I have dark circles" />
                      <CardTitle>I have dark circles</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "nez" && (
                <div>
                  <CardWrapper>
                    <Card onClick={() => this.changeIndication("forme-nez")}>
                      <Img
                        src="/forme-nez.jpg"
                        alt="Change the shape of my nose"
                      />
                      <CardTitle>Change the shape of my nose</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("respirer")}>
                      <Img
                        src="/respirer.jpg"
                        alt="I have difficulty breathing"
                      />
                      <CardTitle>I have difficulty breathing...</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "oreilles" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() =>
                        this.changeIndication("oreilles-decollees")
                      }
                    >
                      <Img
                        src="/oreilles-decollees.jpg"
                        alt="My ears are prominent"
                      />
                      <CardTitle>My ears are prominent</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("lobes")}>
                      <Img src="/lobes.jpg" alt="My earlobes are damaged" />
                      <CardTitle>My earlobes are damaged</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "seins" && (
                <div>
                  <CardWrapper>
                    <Card onClick={() => this.changeIndication("trop-petite")}>
                      <Img
                        src="/trop-petite.jpg"
                        alt="My breasts are too small"
                      />
                      <CardTitle>My breasts are too small</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("tombante")}>
                      <Img src="/tombante.jpg" alt="My breasts are sagging" />
                      <CardTitle>My breasts are sagging</CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("reconstruction")}
                    >
                      <Img
                        src="/reconstruction.jpg"
                        alt="My breast needs to be reconstructed"
                      />
                      <CardTitle>My breast needs to be reconstructed</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "silhouette" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() =>
                        this.changeIndication("redessiner-sa-silhouette")
                      }
                    >
                      <Img
                        src="/redessiner-sa-silhouette.jpg"
                        alt="Reshape my figure"
                      />
                      <CardTitle>Reshape my figure</CardTitle>
                    </Card>

                    <Card
                      onClick={() =>
                        this.changeIndication("perdre-masse-graisseuse")
                      }
                    >
                      <Img
                        src="/perdre-masse-graisseuse.jpg"
                        alt="Lose fat mass"
                      />
                      <CardTitle>Lose fat mass</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "jambes" && (
                <div>
                  <CardWrapper>
                    <Card
                      onClick={() => this.changeIndication("affiner-jambes")}
                    >
                      <Img src="/affiner-jambes.jpg" alt="Slim down my legs" />
                      <CardTitle>Slim down my legs</CardTitle>
                    </Card>

                    <Card
                      onClick={() => this.changeIndication("sculpter-jambes")}
                    >
                      <Img
                        src="/sculpter-jambes.jpg"
                        alt="Sculpt my legs"
                      />
                      <CardTitle>Sculpt my legs</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("cellulite")}>
                      <Img src="/cellulite.jpg" alt="Eliminate cellulite" />
                      <CardTitle>Eliminate cellulite</CardTitle>
                    </Card>
                  </CardWrapper>
                </div>
              )}

              {this.state.zone === "peau" && (
                <div>
                  <CardWrapper>
                    <Card onClick={() => this.changeIndication("terne")}>
                      <Img
                        src="/terne.jpg"
                        alt="My skin is dull and tired"
                      />
                      <CardTitle>My skin is dull and tired</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("relachee")}>
                      <Img src="/relachee.jpg" alt="My skin is lax" />
                      <CardTitle>My skin is lax</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("rides")}>
                      <Img src="/rides.jpg" alt="My skin is wrinkled" />
                      <CardTitle>My skin is wrinkled</CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("cicatrices")}>
                      <Img
                        src="/cicatrices.jpg"
                        alt="I have scars or acne after-effects"
                      />
                      <CardTitle>
                        I have scars or acne after-effects
                      </CardTitle>
                    </Card>

                    <Card onClick={() => this.changeIndication("taches")}>
                      <Img
                        src="/taches.jpg"
                        alt="I have spots or pigmented lesions"
                      />
                      <CardTitle>
                        I have spots or pigmented lesions
                      </CardTitle>
                    </Card>
                  </CardWrapper>
                  <p>&nbsp;</p>
                </div>
              )}
              <Back onClick={() => this.changeStep(0)}>&lt; Back</Back>
            </Wrapper>
          )}

          {this.state.activeStep === 2 && (
            <Wrapper>
              <Step>
                <StepNumber>Step 3/3</StepNumber>
                Treatments suited to your needs
              </Step>

              {this.state.indication === "effacer-rides" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/effacer-rides.jpg" alt="Erase wrinkles" />
                  </IndicationImage>

                  <Indication>
                    <H3>Erase wrinkles</H3>
                    <P>
                      Aesthetic medicine and cosmetic surgery techniques offer
                      several proven types of treatment for removing or
                      reducing wrinkles and fine lines.
                    </P>
                    <P>
                      In aesthetic medicine, these include injections of
                      filler products (hyaluronic acid), the inhibition of
                      certain muscles responsible for expression wrinkles
                      (Botox), or stimulation of the body's own collagen
                      production through laser or Keybody-Skin.
                    </P>
                    <P>
                      In cosmetic surgery, facelifts (notably the LVPA
                      facelift performed by Dr Cédric Kron) correct wrinkles
                      by re-tensioning the skin.
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Medical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/hyaluronic-acid/">
                              Hyaluronic acid
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/forehead-wrinkles-hyaluronic-acid/">
                              Forehead wrinkle filling
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/silhouette-soft-thread-lift/">
                              Thread lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/botox-injections/">
                              Botox injections
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/eyes/botox-crows-feet/">
                              Remove crow's feet wrinkles
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Surgical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/cervicofacial-facelift/">
                              Cervicofacial facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/eyes/forehead-lift/">
                              Forehead lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/facelift-lvpa/">
                              LVPA facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/deep-plane-facelift/">
                              Deep plane facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/cheek-lift-under-eye-circles/">
                              Cheek lift
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "restaurer-volumes" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/restaurer-volumes.jpg"
                      alt="Restore the volume of my face"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Restore the volume of my face</H3>
                    <P>
                      The loss of facial volume is mainly explained by the
                      natural phenomenon of skin aging. With age, and
                      particularly at menopause, hormone levels decrease,
                      resulting in a lower production of the cells essential
                      for "filling" the skin and responsible for its smooth,
                      firm appearance.
                    </P>
                    <P>
                      This phenomenon of facial volume loss is sometimes
                      referred to as skin sagging, loss of facial density, or
                      loss of facial contours. There are medical and surgical
                      techniques that naturally and durably restore this
                      volume.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Medical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/hyaluronic-acid/">
                              Hyaluronic acid
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/ellanse/">
                              ELLANSÉ®
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/silhouette-soft-thread-lift/">
                              Thread lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/dynamic-phototherapy/">
                              Dynamic phototherapy
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/neck-rejuvenation-botox/">
                              Neck rejuvenation (Botox)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/jaw-reduction-botox/">
                              Jaw reduction
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/lip-aesthetic-treatment/">
                              Plump the lips (hyaluronic acid)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/jowls-fat-removal/">
                              Remove jowls
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Surgical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/chin-surgery-genioplasty/">
                              Chin surgery (Genioplasty)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/cervicofacial-facelift/">
                              Cervicofacial facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/neck-lift-platysmaplasty/">
                              Neck lift (Platysmaplasty)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/facelift-lvpa/">
                              LVPA facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/deep-plane-facelift/">
                              Deep plane facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/cheek-lift-under-eye-circles/">
                              Cheek lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/double-chin-removal/">
                              Chin liposuction
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/lip-aesthetic-treatment/">
                              Lip lipofilling
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "supprimer-imperfections" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/peau.jpg"
                      alt="Remove skin imperfections"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Remove skin imperfections</H3>
                    <P>
                      For several years now, new aesthetic medicine
                      techniques have allowed for better treatment of skin
                      imperfections: results are more significant, sessions
                      more comfortable and side effects milder.
                    </P>
                    <P>
                      Among the skin imperfections that can be reduced by
                      aesthetic medicine are stretch marks, dilated pores, sun
                      spots (lentigo), rosacea, redness, freckles, milia, as
                      well as the after-effects of acne and chickenpox.
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/rosacea-redness-laser-treatment/">
                              Rosacea, redness
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/carboxytherapy/">
                              Facial carboxytherapy
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/mesolift-nctf/">
                              Mesolift NCTF
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/combined-peel/">
                              Combined peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/biorevitalization-peel-prx-t33/">
                              Biorevitalizing peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "rajeunir-peau" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/rajeunir-peau.jpg"
                      alt="Rejuvenate the skin of my face"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Rejuvenate the skin of my face</H3>
                    <P>
                      Aesthetic medicine techniques for treating facial skin
                      aging are particularly effective in correcting
                      wrinkles, skin laxity, volume loss or lack of
                      hydration.
                    </P>
                    <P>
                      To support you in treating the signs of facial aging,
                      Dr Kron and his team have set up a facial diagnostic
                      pre-consultation, which aims to inform you based on
                      your request and anatomy, in order to establish a
                      tailored therapeutic protocol and comprehensive care
                      for the rejuvenation of your face.
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/carboxytherapy/">
                              Facial carboxytherapy
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/ellanse/">
                              ELLANSÉ®
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/mesolift-nctf/">
                              Mesolift NCTF
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/combined-peel/">
                              Combined peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/biorevitalization-peel-prx-t33/">
                              Biorevitalizing peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "modifier-forme-paupieres" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/modifier-forme-paupieres.jpg"
                      alt="Change the shape of my eyelids"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Change the shape of my eyelids</H3>
                    <P>
                      A blepharoplasty is a cosmetic eyelid surgery aimed at
                      enhancing the eyes by removing imperfections around the
                      eyelids. These are notably imperfections caused by
                      aging, such as wrinkles around the eyes or full
                      pockets/dark circles.
                    </P>
                    <P>
                      Eyelid surgery can also concern younger patients who
                      wish to change the initial shape of their eyelids
                      (congenital eyelid fold, Asian or Eurasian eyelid). In
                      the case of Asian blepharoplasty, the aim is less to
                      "westernize" the eyes than to enhance them, creating a
                      more almond-shaped or more open look.
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Ul>
                        <Li>
                          <StyledLink to="/en/eyes/blepharoplasty-eyelid-surgery/">
                            Blepharoplasty
                          </StyledLink>
                        </Li>
                        <Li>
                          <StyledLink to="/en/eyes/double-eyelid-asian-blepharoplasty/">
                            Asian blepharoplasty
                          </StyledLink>
                        </Li>
                        <Li>
                          <StyledLink to="/en/eyes/plexr/">Plexr</StyledLink>
                        </Li>
                      </Ul>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "tiers-superieur" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/tiers-superieur.jpg"
                      alt="Rejuvenate the upper third of the face"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Rejuvenate the upper third of the face</H3>
                    <P>
                      Aging of the upper third of the face is caused by
                      three natural phenomena: the effect of gravity, the
                      action of the frontal muscle causing transverse
                      wrinkles, and the action of the muscles that lead to
                      vertical furrows (frown lines).
                    </P>
                    <P>
                      Cosmetic surgery or aesthetic medicine treatments such
                      as facelifts, peels, and Botox or hyaluronic acid
                      injections rejuvenate the upper third of the face by
                      re-tensioning the skin and reducing forehead and frown
                      lines.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Medical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/carboxytherapy/">
                              Facial carboxytherapy
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/mesolift-nctf/">
                              Mesolift NCTF
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/combined-peel/">
                              Combined peel
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/en/skin/biorevitalization-peel-prx-t33/">
                              Biorevitalizing peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Surgical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/eyes/forehead-lift/">
                              Forehead lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/cheek-lift-under-eye-circles/">
                              Cheek lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/facelift-lvpa/">
                              LVPA facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/deep-plane-facelift/">
                              Deep plane facelift
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "cernes" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/cernes.jpg" alt="I have dark circles…" />
                  </IndicationImage>

                  <Indication>
                    <H3>I have dark circles…</H3>
                    <P>
                      The generic term "dark circles" covers several
                      different, sometimes combined, conditions affecting the
                      area below the eyes.
                    </P>

                    <P>
                      There are different types of dark circles — hollow
                      dark circles, pigmented dark circles and full dark
                      circles (sometimes called "under-eye bags") — for
                      which several medical and surgical techniques exist to
                      prevent their occurrence and/or reduce them.
                    </P>

                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/types-of-under-eye-circles/">
                              The different types of dark circles
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/cheek-lift-under-eye-circles/">
                              Surgery for full dark circles and under-eye bags
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/hyaluronic-acid-under-eye-circles/">
                              Filling hollow dark circles
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/cheek-lift-under-eye-circles/">
                              Cheek lift: Surgery for hollow dark circles
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/under-eye-circles-lipofilling/">
                              Under-eye circles lipofilling
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/pigmented-under-eye-circles-peel/">
                              Pigmented dark circles: Depigmenting peel
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "forme-nez" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/forme-nez.jpg"
                      alt="Change the shape of my nose"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Change the shape of my nose</H3>
                    <P>
                      The nose is one of the most important elements of a
                      face's harmony. It is this harmony that gives a face
                      its appeal, not the juxtaposition of standardized
                      features. When treating the shape of the nose, it is
                      essential to avoid the stereotype of a "redone" nose.
                    </P>
                    <P>
                      There are several medical (hyaluronic acid injection)
                      and cosmetic surgery techniques for the nose
                      (rhinoplasty, septoplasty) to correct the appearance of
                      the nose and smooth out certain imperfections, whether
                      congenital, resulting from trauma, or caused by aging.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Surgical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/nose/rhinoplasty/">
                              Rhinoplasty
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/nose/ethnic-rhinoplasty/">
                              Ethnic rhinoplasty
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/nose/revision-rhinoplasty/">
                              Revision rhinoplasty
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Medical treatment</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/nose/non-surgical-rhinoplasty/">
                              Non-surgical rhinoplasty
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "respirer" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/respirer.jpg"
                      alt="I have difficulty breathing..."
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>I have difficulty breathing...</H3>
                    <P>
                      A deviated nasal septum is a deformation of the inner
                      wall of the nose. This deviation can affect the
                      cartilage or the bones of the nose, or both. A deviated
                      septum can be caused by a malformation or by trauma to
                      the nose following an impact.
                    </P>
                    <P>
                      A deviated nasal septum can cause medical issues:
                      chronic nasal obstruction, breathing difficulties,
                      snoring, even sinus and ear infections and sometimes
                      migraines. A deviated septum can also cause an
                      unsightly deformity of the shape of the nose (the nose
                      is partially deviated to one side).
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/nose/septoplasty/">
                              Septoplasty: Deviated nasal septum
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/nose/migraine-septoplasty/">
                              Migraine treatment by septoplasty
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/nose/revision-rhinoplasty/">
                              Revision rhinoplasty
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "oreilles-decollees" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/oreilles-decollees.jpg"
                      alt="My ears are prominent"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>My ears are prominent</H3>
                    <P>
                      Ears can be considered "prominent" when the angle they
                      form with the skull is greater than average and/or when
                      the concha is not parallel to the skull. The ears then
                      appear too visible when seen from the front.
                    </P>
                    <P>
                      Surgical correction of prominent ears can be performed
                      on adults, teenagers and children. Under certain
                      conditions, an otoplasty may be covered by French
                      social security and supplemental health insurance.
                      <br />
                      &nbsp;
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Surgical treatment</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/ears/otoplasty-prominent-ears-surgery/">
                              Otoplasty
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Medical treatment</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/ears/earfold-prominent-ears-treatment/">
                              EarFold implants
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "lobes" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/lobes.jpg" alt="My earlobes are damaged" />
                  </IndicationImage>

                  <Indication>
                    <H3>My earlobes are damaged</H3>
                    <P>
                      The earlobe is the lower part of the ear. It is made up
                      of fatty tissue and contains no cartilage. The earlobe
                      is a particularly delicate and vulnerable part of the
                      face. It is made up of fragile skin that lacks the
                      support of cartilage — unlike other parts of the outer
                      ear.
                    </P>
                    <P>
                      An aesthetic treatment of the earlobes is indicated for
                      patients bothered by the appearance of their earlobes
                      (too large or misshapen), as well as those who have
                      experienced a torn earlobe (from trauma) or a stretched
                      earlobe from wearing heavy earrings or gauges.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/ears/split-torn-stretched-earlobe-surgery/">
                              Surgery for split, torn or stretched earlobes{" "}
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "trop-petite" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/trop-petite.jpg"
                      alt="My breasts are too small"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>My breasts are too small</H3>
                    <P>
                      Since adolescence, you have felt your breasts were too
                      small, too underdeveloped. They did not match the image
                      you had of yourself and your femininity. Breast
                      augmentation is a way to align your image of femininity
                      with your body, to feel more like a woman.
                    </P>
                    <P>
                      Breast augmentation can also accentuate the femininity
                      of your silhouette, further enhancing your breasts so
                      you feel more attractive.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/breast/breast-implants/">
                              Breast augmentation with implants
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/local-anesthesia-cosmetic-surgery/#augmentation-mammaire">
                              Breast augmentation under local anesthesia
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/breast/breast-lipofilling/">
                              Breast lipofilling
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/breast/motiva-preserve/">
                              Motiva Preserve
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "tombante" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/tombante.jpg" alt="My breasts are sagging" />
                  </IndicationImage>

                  <Indication>
                    <H3>My breasts are sagging</H3>
                    <P>
                      After a pregnancy or significant weight loss, you have
                      seen your breasts sag, lose their shape and flatten.
                      You no longer recognize yourself with this "sagging"
                      bust that doesn't match the image you have of
                      yourself. You want to regain the firmness and volume of
                      your breasts as they were before (or even a little
                      more). Breast surgery would allow you to feel like
                      yourself again as a woman, correcting the effects of
                      past years.
                    </P>
                    <P>
                      If breast volume is too large relative to the rest of
                      the body, a breast reduction can achieve breasts that
                      are harmonious with your anatomy and match your wishes.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/breast/breast-lift/">
                              Breast ptosis correction
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/mommy-makeover/">
                              Mommy Makeover
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/breast/motiva-preserve/">
                              Motiva Preserve
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/breast/breast-lift/">
                              Breast lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/breast/breast-reduction/">
                              Breast reduction
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "reconstruction" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/reconstruction.jpg"
                      alt="My breast needs to be reconstructed"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>My breast needs to be reconstructed</H3>
                    <P>
                      Breast reconstruction aims to restore the volume and
                      contours of the breast and to reconstruct the areola
                      and nipple. Most often, a first procedure recreates the
                      shape and volume of the breast, and a second procedure
                      reconstructs the areola and nipple.
                    </P>
                    <P>
                      Some women who have had breast augmentation may decide
                      at some point in their lives that they want to return
                      to their original breasts or change their breast
                      shape. While breast augmentation is a reversible
                      procedure and implant removal can achieve a very
                      natural result, it is important that this decision be
                      carefully considered and made for the right reasons.
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/breast/breast-reconstruction-surgery/">
                              Breast reconstruction
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/breast/breast-implant-removal/">
                              Breast implant removal
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "redessiner-sa-silhouette" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/redessiner-sa-silhouette.jpg"
                      alt="Reshape my figure"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Reshape my figure</H3>

                    <P>
                      To support you in removing fat and toning your body's
                      architecture, Dr Kron's practice offers a{" "}
                      <Link to="/en/body-contouring/consultation/">
                        body contouring diagnostic pre-consultation
                      </Link>{" "}
                      during which you will be guided through the various
                      treatments available to reshape and slim your figure.
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Surgical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/body-lift/">
                              Body lift
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/en/body-contouring/buttock-implants/">
                              Buttock implants
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/liposuction/">
                              Liposuction
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/local-anesthesia-cosmetic-surgery/#liposuccion-douce">
                              Gentle liposuction (local anesthesia)
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/legs/calf-lipofilling/">
                              Calf lipofilling
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/mommy-makeover/">
                              Mommy makeover
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/tummy-tuck/">
                              Tummy tuck
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/arms/arm-lift/">
                              Arm lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/legs/calf-implants/">
                              Calf implants
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Medical techniques</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/emsculpt/">
                              EMSculpt
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/xbody-reshape-body-ems/">
                              XBody
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/cryolipolysis-coolsculpting/">
                              CoolSculpting
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "perdre-masse-graisseuse" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/perdre-masse-graisseuse.jpg"
                      alt="Lose fat mass"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Lose fat mass</H3>
                    <P>
                      For a long time, liposuction was the reference cosmetic
                      surgery technique for removing unsightly fat deposits
                      resistant to exercise and dieting. There are now
                      aesthetic medicine techniques such as Keybody-Lipo,
                      EMSculpt and cryolipolysis for slimming the figure.
                    </P>
                    <P>
                      To support you in removing fat and toning your body's
                      architecture, Dr Kron's practice offers a{" "}
                      <Link to="/en/body-contouring/consultation/">
                        body contouring diagnostic pre-consultation
                      </Link>{" "}
                      during which you will be guided through the various
                      treatments available to reshape and slim your figure.
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Surgical techniques</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/liposuction/">
                              Liposuction
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/local-anesthesia-cosmetic-surgery/#liposuccion-douce">
                              Gentle liposuction (local anesthesia)
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/en/body-contouring/saddlebags-liposuction/">
                              Saddlebags liposuction
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/body-lift/">
                              Body lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/legs/calf-liposuction/">
                              Calf liposuction
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Medical techniques</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/cryolipolysis-coolsculpting/">
                              Cryolipolysis with CoolSculpting
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/emsculpt/">
                              EMSculpt
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/keybody-lipo/">
                              Keybody-Lipo
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/keybody-cellulite/">
                              Keybody-Cellulite
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/en/body-contouring/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/xbody-reshape-body-ems/">
                              X-Body
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "affiner-jambes" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/affiner-jambes.jpg" alt="Slim down my legs" />
                  </IndicationImage>

                  <Indication>
                    <H3>Slim down my legs</H3>
                    <P>
                      To slim down the legs and remove localized fat
                      deposits, liposuction of the thighs and/or calves is
                      the most suitable surgical procedure. If the fatty
                      tissue is accompanied by significant skin laxity,
                      particularly on the inner thighs, liposuction may be
                      combined with a thigh lift.
                    </P>
                    <P>
                      New aesthetic medicine techniques also help slim the
                      legs by removing fat and sculpting the leg muscles.
                      <br />
                      &nbsp;
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Surgical techniques</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/legs/calf-liposuction/">
                              Calf liposuction
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/legs/thigh-lift/">
                              Thigh lift
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Medical techniques</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/cryolipolysis-coolsculpting/">
                              Cryolipolysis with Coolsculpting
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/keybody-lipo/">
                              Keybody-Lipo
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/en/body-contouring/xbody-reshape-body-ems/">
                              X-Body
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "sculpter-jambes" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/sculpter-jambes.jpg"
                      alt="Sculpt my legs"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>Sculpt my legs</H3>
                    <P>
                      Calf lipofilling is a cosmetic surgery procedure
                      particularly suited to correcting a lack of shape in
                      the calves. A lasting enhancement of calf contours is
                      also possible with the placement of an implant.
                    </P>
                    <P>
                      There are also medical muscle-sculpting treatments such
                      as Keybody-Lipo and X-Body that achieve very good
                      results on the shape of the legs.
                      <br />
                      &nbsp;
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Surgical techniques</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/legs/thigh-lift/">
                              Thigh lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/legs/calf-lipofilling/">
                              Calf lipofilling
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/legs/calf-implants/">
                              Calf implants
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Medical techniques</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/keybody-lipo/">
                              Keybody-Lipo
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/xbody-reshape-body-ems/">
                              XBody
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "cellulite" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/cellulite.jpg" alt="Eliminate cellulite" />
                  </IndicationImage>

                  <Indication>
                    <H3>Eliminate cellulite</H3>
                    <P>
                      Cellulite affects many women, regardless of age, size
                      or weight. "Orange peel skin" is difficult to
                      eliminate despite a balanced diet, regular exercise, or
                      regular use of massages or anti-cellulite creams.
                    </P>
                    <P>
                      To permanently eliminate cellulite, there are
                      effective medical treatments that can be combined to
                      achieve the best possible result. Among the most
                      effective treatments for eliminating cellulite are
                      ONDA Coolwaves and cryolipolysis with Coolsculpting,
                      which can be combined as part of the Keybody-Cellulite
                      protocol.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/keybody-cellulite/">
                              Keybody-Cellulite
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/onda-coolwaves/">
                              ONDA Coolwaves
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "terne" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/terne.jpg"
                      alt="My skin is dull and tired"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>My skin is dull and tired</H3>
                    <P>
                      Wrinkles and fine lines, acne scars, stretch marks,
                      loss of elasticity, pigment spots, benign growths,
                      blackheads, dry, lax or inflammation-prone skin... Skin
                      is the part of the body that acts as a barrier with the
                      outside world, and is therefore one of the most
                      sensitive to environmental aggressions and the passage
                      of time.
                    </P>
                    <P>
                      Aesthetic skin treatments have evolved considerably in
                      recent years and now offer genuinely significant
                      results for many indications. To help you review the
                      various existing techniques, Dr Kron and his team offer
                      a{" "}
                      <Link to="/en/face/face-treatment-diagnosis/">
                        pre-consultation diagnosis of your skin condition
                      </Link>
                      .
                    </P>

                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/carboxytherapy/">
                              Carboxytherapy
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/hydrafacial/">
                              HydraFacial
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/biorevitalization-peel-prx-t33/">
                              Biorevitalizing peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/combined-peel/">
                              Combined peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/platelet-rich-plasma-prp/">
                              Platelet-Rich Plasma
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "relachee" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/relachee.jpg" alt="My skin is lax" />
                  </IndicationImage>

                  <Indication>
                    <H3>My skin is lax</H3>
                    <P>
                      The first signs of aging are not tied to a specific
                      age, as they appear as early as your twenties, when
                      collagen and elastin levels — the proteins that give
                      skin its structure — begin to decline. You will start
                      to notice a loss of skin firmness. The first wrinkles
                      will appear. The more time passes, the more pronounced
                      the effect will become.
                    </P>
                    <P>
                      Folds and wrinkles are part of the aging process, but
                      that doesn't mean there is no solution. As collagen
                      levels decline over time, skin loses its elasticity
                      and wrinkles appear.
                    </P>

                    <FlexIndication>
                      <Half>
                        <H4>Medical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/ellanse/">
                              ELLANSÉ®
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/mesolift-nctf/">
                              Mesolift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/silhouette-soft-thread-lift/">
                              Thread lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/news/sisthaema/">
                              Sisthaema
                            </StyledLink>
                          </Li>

                          <Li>
                            <StyledLink to="/en/face/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Surgical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/body-contouring/body-lift/">
                              Body lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/arms/arm-lift/">
                              Arm lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/legs/thigh-lift/">
                              Thigh lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/eyes/forehead-lift/">
                              Forehead lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/facelift-lvpa/">
                              LVPA facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/deep-plane-facelift/">
                              Deep plane facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/cervicofacial-facelift/">
                              Cervicofacial facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/under-eye-circles/cheek-lift-under-eye-circles/">
                              Cheek lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/body-contouring/mommy-makeover/">
                              Mommy makeover
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "rides" && (
                <Flex>
                  <IndicationImage>
                    <Image src="/rides.jpg" alt="My skin is wrinkled" />
                  </IndicationImage>

                  <Indication>
                    <H3>My skin is wrinkled</H3>
                    <P>
                      Aesthetic medicine and cosmetic surgery techniques
                      offer several proven types of treatment for removing
                      or reducing wrinkles and fine lines.
                    </P>
                    <P>
                      In aesthetic medicine, these include injections of
                      filler products (hyaluronic acid), the inhibition of
                      certain muscles responsible for expression wrinkles
                      (Botox), or stimulation of the body's own collagen
                      production through laser, radiofrequency or peels.
                    </P>
                    <P>
                      In cosmetic surgery, facelifts (notably the LVPA
                      facelift developed by Dr Cédric Kron) correct wrinkles
                      by re-tensioning the skin.
                      <br />
                      &nbsp;
                    </P>
                    <FlexIndication>
                      <Half>
                        <H4>Medical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/hyaluronic-acid/">
                              Hyaluronic acid
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/forehead-wrinkles-hyaluronic-acid/">
                              Forehead wrinkle filling
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/forehead-wrinkles-botox/">
                              Botox injection
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/eyes/botox-crows-feet/">
                              Botox: Remove crow's feet
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/forehead-wrinkles-botox/">
                              Botox: Forehead wrinkles
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/crows-feet-chemical-peel/">
                              Peel: Crow's feet wrinkles
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/eyes/plexr/">Plexr</StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <H4>Surgical treatments</H4>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/local-anesthesia-cosmetic-surgery/#mini-lift">
                              Mini-Lift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/facelift-lvpa/">
                              LVPA facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/deep-plane-facelift/">
                              Deep plane facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/cervicofacial-facelift/">
                              Cervicofacial facelift
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/eyes/forehead-lift/">
                              Forehead lift
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "cicatrices" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/cicatrices.jpg"
                      alt="I have scars or acne after-effects"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>I have scars or acne after-effects</H3>
                    <P>
                      A scar is the visible part of a lesion in the dermis.
                      It is an integral part of the skin healing process. A
                      scar can result from trauma (an injury) or a surgical
                      operation (following an incision in the dermis). All
                      skin lesions leave scars, except the most superficial
                      ones, which affect only the epidermis.
                    </P>
                    <P>
                      Aesthetic medicine treatments such as Radiofrequency,
                      the Icon laser, LaseMD Ultra, Keybody-Skin or PlexR
                      achieve good results in reducing certain types of
                      scars, particularly acne scars.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/skin/scar-revision/">
                              Scar revision surgery
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/universkin/">
                              Universkin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/combined-peel/">
                              Combined peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/biorevitalization-peel-prx-t33/">
                              Biorevitalizing peel
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              {this.state.indication === "taches" && (
                <Flex>
                  <IndicationImage>
                    <Image
                      src="/taches.jpg"
                      alt="I have spots or pigmented lesions"
                    />
                  </IndicationImage>

                  <Indication>
                    <H3>I have spots or pigmented lesions</H3>
                    <P>
                      The latest generations of medical skin treatments
                      effectively treat pigmented spots and lesions (melasma,
                      heliodermia, lentigos, actinic keratosis, age spots,
                      freckles), superficial skin irregularities (such as
                      chickenpox or acne scars), all while restoring the
                      skin's radiance. These treatments include LaseMD
                      Ultra, ONDA Coolwaves and Plexr.
                    </P>

                    <P>
                      For an even more significant result, Dr Cédric Kron has
                      developed protocols that combine several medical skin
                      treatments. These protocols correct laxity of the
                      facial oval, deeply regenerate the skin, and treat
                      pigmented spots and lesions all at once.
                      <br />
                      &nbsp;
                    </P>
                    <Plus>Learn more:</Plus>

                    <FlexIndication>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/face/rosacea-redness-laser-treatment/">
                              Rosacea and redness
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/combined-peel/">
                              Combined peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/biorevitalization-peel-prx-t33/">
                              Biorevitalizing peel
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/skinbooster/">
                              Skinbooster
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/stretch-marks/">
                              Stretch marks treatment
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                      <Half>
                        <Ul>
                          <Li>
                            <StyledLink to="/en/skin/ultraclear-laser/">
                              UltraClear laser
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/lasemd-ultra/">
                              LaseMD Ultra
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/laser-icon-skin-imperfections/">
                              Laser Icon
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/face/universkin/">
                              Universkin: Medical cosmetics
                            </StyledLink>
                          </Li>
                          <Li>
                            <StyledLink to="/en/skin/keybody-skin/">
                              Keybody-Skin
                            </StyledLink>
                          </Li>
                        </Ul>
                      </Half>
                    </FlexIndication>
                  </Indication>
                </Flex>
              )}

              <Back onClick={() => this.changeStep(1)}>&lt; Back</Back>
            </Wrapper>
          )}
        </MultiStep>
      </div>
    );
  }
}

const Wrapper = styled.div`
  padding: 30px 4px 20px;
  min-height: 735px;
`;

const MultiStep = styled.div`
  width: 1100px;
  max-width: 100%;
  margin: 0 auto 120px;
  position: relative;
`;

const Step = styled.div`
  cursor: default;
  text-align: center;
  font-size: 1.2em;
  width: 100%;
  margin-bottom: 45px;
  font-weight: 600;
  color: #3c4d68;
  @media (max-width: 678px) {
    margin-bottom: 60px;
  }
`;

const StepNumber = styled.div`
  font-size: 0.65em;
  color: white;
  background-color: #3c4d68;
  width: 88px;
  margin: 0 auto;
  border-radius: 18px;
  font-style: normal;
  margin-bottom: 10px;
`;

const CardWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-row: 2fr 2fr 2fr 2fr;

  @media (max-width: 1000px) {
    grid-template-columns: 33% 33% 33%;
    grid-template-row: 2fr 2fr 2fr;
  }
  @media (max-width: 678px) {
    grid-template-columns: 50% 50%;
    grid-template-row: 2fr 2fr;
  }
`;

const Card = styled.button`
  cursor: pointer;
  position: relative;
  width: 100%;
  border-radius: 8px;
  border: none;
  padding: 0.8em;
  background-color: white;
  transition: all 0.3s ease-in-out;
  transform: scale(1);
  :hover {
    transition: all 0.3s ease-in-out;
    transform: scale(1.02);
  }
  @media (max-width: 678px) {
    padding: 0.3em;
  }
`;

const Img = styled.img`
  max-width: 100%;
  filter: grayscale(100%);
  border-radius: 8px;
  :hover {
    filter: grayscale(0%);
  }
  @media (max-width: 678px) {
    filter: none;
  }
  @media (min-width: 900px) {
    width: 260px;
    height: 260px;
  }
`;

const CardTitle = styled.div`
  position: absolute;
  bottom: 30px;
  text-align: center;
  background-color: white;
  width: 90%;
  font-size: 1.26em;
  font-weight: 700;
  color: rgb(60, 77, 104);
  padding: 8px;
  letter-spacing: 0.03em;
  @media (max-width: 678px) {
    font-size: 1.1em;
    width: 92%;
    padding: 4px;
    bottom: 17px;
  }
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 678px) {
    display: block;
    padding: 0 10px;
  }
`;

const FlexIndication = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 678px) {
    display: block;
  }
`;

const IndicationImage = styled.div`
  width: 25%;
  padding: 11px 35px 10px 10px;
  @media (max-width: 678px) {
    width: 100%;
    padding: 0;
  }
`;

const Indication = styled.div`
  width: 75%;
  padding: 0 1em 0 1.5em;
  @media (max-width: 678px) {
    width: 100%;
    padding: 0;
  }
`;

const Image = styled.img`
  border-radius: 8px;
  max-width: 100%;
`;

const H3 = styled.h3`
  font-size: 2em;
  font-weight: 700;
  margin: 0.5em 0 0.65em;
  @media (max-width: 678px) {
    text-align: center;
    font-size: 1.55em;
    line-height: 1.28em;
    margin: 0.25em 0 0.35em;
  }
`;

const P = styled.p`
  font-weight: 400;
  font-size: 1.01em;
  line-height: 1.62em;
  @media (max-width: 678px) {
    font-size: 1.02em;
    line-height: 1.56em;
  }
`;

const Half = styled.div`
  padding-top: 5px;
  flex: 50%;
  @media (max-width: 678px) {
    width: 100%;

    padding-top: 0;
  }
`;

const H4 = styled.h4`
  text-align: center;
  font-size: 1.1em;
  letter-spacing: 0.02em;
  font-weight: 700;
  background-color: #3c4d68;
  color: white;
  display: inline-block;
  margin: 0.2 auto 0.5em;
  border: 1px solid #3c4d68;
  border-radius: 6px;
  padding: 0.15em 1em;
  @media (max-width: 678px) {
    margin: 0 auto;
    margin-bottom: 12px;
    margin-top: 10px;
  }
`;

const Plus = styled.p`
  color: #3c4d68;
  font-size: 1.3em;
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 5px;
  @media (max-width: 678px) {
    margin-bottom: 12px;
  }
`;

const Ul = styled.ul`
  margin: 0 !important;
  list-style: none;
  @media (max-width: 678px) {
  }
`;

const Li = styled.li`
  font-size: 1em;
  margin-bottom: 0.3em;
  :before {
    content: "➔ ";
    color: #3c4d68;
    font-size: 0.8em;
    font-weight: bold;
    display: inline-block;
    width: 2em;
    margin-left: 0em;
  }
  @media (max-width: 678px) {
    :before {
    }
  }
`;

const StyledLink = styled(Link)`
  border-bottom: none;
`;

const Back = styled.button`
  position: absolute;
  top: 100px;
  color: white;
  background-color: #3c4d68;
  border: 1px solid #3c4d68;
  padding: 0.5em 1.5em;
  margin-left: 10px;
  display: block;
  border-radius: 7px;
  text-align: center;
  font-weight: 700;
  width: 150px;
  text-decoration: none;
  letter-spacing: 0.03em;
  transition: all 0.3s ease-in-out 0s;
  hover {
    background-color: white;
    color: #3c4d68;
    transition: all 0.3s ease-in-out 0s;
  }
  @media (max-width: 678px) {
    margin-left: 3px;
    padding: 0.5em 0.75em;
    width: 90px;
  }
`;
